export function inputNotOfTypeFile() {
 return "Obtener archivos seleccionados de un input con type distinto de file."
}